import { api } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type { MfaConfirmResponse, MfaProofRequest } from '@eye-able/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/** New backup codes; the old ones stop working at once. */
export function useRegenerateBackupCodes() {
  const queryClient = useQueryClient();

  return useMutation({
    // The codes must not linger in the cache.
    gcTime: 0,
    mutationFn: (body: MfaProofRequest) =>
      fetchWrapper.post<MfaConfirmResponse>(api.mfaBackupCodes, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [api.mfa] }),
  });
}
